module.exports = __webpack_public_path__ + "static/media/leftmn.ba3b8b06.png";